$(document).on('turbo:load', function() {

  $('.tmd-single-dropdown').change(function() {
    const value = $(this).val();
    if (value === 'Other') $(this).siblings('.tmd-single-dropdown-other').removeClass('d-none');
    else $(this).siblings('.tmd-single-dropdown-other').val('').addClass('d-none');
  });

  const hasAttorneyField = $('#has-attorney-field');
  const attorneyFields = $('#attorney-fields');
  hasAttorneyField.change(function() {
    const value = $(this).val();
    if (value === 'Yes') {
        attorneyFields.removeClass('d-none');
        attorneyFields.find('.required-field').prop('required', true);
    } else {
        attorneyFields.addClass('d-none');
        attorneyFields.find('.required-field').prop('required', false);
        attorneyFields.find('input, select').val('');
    }
  });

  // Brand Sumary Example Modal
  const titleDescriptionModal = $('#notice-brand-summary-modal');
  const titleDescriptionModalTitle = $('#notice-modal-title');
  const titleDescriptionModalDescription = $('#notice-modal-description');
  const summaryModalTriggerBtn = $('#notice-modal-brand-summary-btn');
  function triggerTitleDescriptionModal(element) {
      // Get properties from element
      const identifier = element.attr('identifier')
      const title = element.attr('title')
      const description = element.attr('description')

      // Update Modal
      if (identifier) titleDescriptionModal.attr('identifier', identifier);
      if (title) titleDescriptionModalTitle.text(title);
      if (description) titleDescriptionModalDescription.html(description.replace(/\n/g, '<br>'));

      // Show Modal
      titleDescriptionModal.modal({backdrop: 'static', keyboard: false}).modal('show');
  }

  // Trigger Modal on button click
  summaryModalTriggerBtn.click(function() {
      triggerTitleDescriptionModal($(this));
  });

  // Show onboarding steps in two minute drill
  $('.onboarding-step-banner .show-step').click(function() {
      const step = $(this).attr('step');
      $(step).removeClass('d-none');
      $(this).addClass('d-none');
  });

  $("#auto_sign").click(function(e){
    e.preventDefault(); // prevent the form submission

    // auto fill certify_name and certify_signature
    let certifyName = $(this).data("certify-name");
    let certifySignature = $(this).data("certify-signature");
    $("#certify_name").val(certifyName);
    $("#certify_signature").val(certifySignature);
    $('input[name="hs_brand[certify_accurate]"]').prop('checked', true);
  });

  const skipThreeUnitInvestmentRangeDropdown = $('select[name="hs_brand[skip_item_7_3_unit]"]');
  const threeUnitInvestmentRangeTr = $('input[name="hs_brand[item_7_3_unit_low]"]').closest('tr');
  skipThreeUnitInvestmentRangeDropdown.change(function() {
    toggleThreeUnitInvestmentRange($(this).val());
  });
  function toggleThreeUnitInvestmentRange(skip_item_7_3_unit_val) {
    if (skip_item_7_3_unit_val === 'Yes') threeUnitInvestmentRangeTr.hide();
    else threeUnitInvestmentRangeTr.show();
  }
  toggleThreeUnitInvestmentRange(skipThreeUnitInvestmentRangeDropdown.val());

  // Element we are adding class to for banner, only top buttons, which is why we grab first
  const editBtnsContainer = $('#two-minute-drill-top-form .tmd-draft-btn-container')
  // Need scroll container because overflow settings block the window
  const scrollContainer = $('#two-minute-drill-top-form').closest('.body-container')

  if (editBtnsContainer.length && scrollContainer.length) {
    // Setting scroll target for screen, accounting for banner at top(70)
    const scrollTargetTop = editBtnsContainer.first()?.offset()?.top - 70;
    const scrollTargetBottom = editBtnsContainer.last()?.offset()?.top - 70 - scrollContainer.height() - editBtnsContainer.height();

    scrollContainer.on('scroll', function() {
      let thisTop = $(this).scrollTop()
      if (thisTop >= scrollTargetTop && thisTop <= scrollTargetBottom)
        editBtnsContainer.first().addClass('tmd-btn-banner')
      else
        editBtnsContainer.first().removeClass('tmd-btn-banner')
      }
    );
  }

  editBtnsContainer.find('.decline-draft-btn').click(function() {
    $(this).closest('.default-container').addClass('d-none');
    $(this).closest('.tmd-draft-btn-container').find('.decline-container').removeClass('d-none');
  });
  editBtnsContainer.find('.cancel-decline-draft-btn').click(function() {
    $(this).closest('.decline-container').addClass('d-none');
    $(this).closest('.tmd-draft-btn-container').find('.default-container').removeClass('d-none');
  });
});
